import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { 
      value: 1,
      name: i18n.t('tipos.operador.equals'),
      nombreTag: i18n.t('tipos.operador.equals_tag'),
    },
    { 
      value: 2,
      name: i18n.t('tipos.operador.contains'),
      nombreTag: i18n.t('tipos.operador.contains_tag'),
    },
    { 
      value: 3,
      name: i18n.t('tipos.operador.starts_with'),
      nombreTag: i18n.t('tipos.operador.starts_with_tag'),
    },
  ]
}

export function OPERADORES (state) {
  return configHelper.getConfig(state, 'OPERADORES', GenerateConfig)
}
